// extracted by mini-css-extract-plugin
export var breadcrumb = "_10-2";
export var breadcrumbArrow = "_10-3";
export var breadcrumbs = "_10-0";
export var link = "_10-4";
export var small = "_10-1";